import React from 'react';
import { SpaceBase } from '@confluence/space-base';

export default (props) => {
	return <SpaceBase {...props} />;
};
